import { FunctionComponent } from 'react'
import moment from 'moment-timezone'
import { Daycare, DaycareType } from '@/types/Daycare'
import styles from './daycareParentProfile.module.scss'
import profileStyles from '../DaycareProfileHandler.module.scss'
import Title from '@/components/_custom/Title/title'
import UserInput from '@/components/_custom/UserInput/userInput'
import { useTranslation } from 'react-i18next'
import { Table, TableBody, TableCell, TableRow } from '@mui/material'
import { daycareTypeToString } from '@/modules/helper/daycareHelper'
import { LocationOn } from '@mui/icons-material'
import CountrySelect from '@/components/_custom/CountrySelect/countrySelect'
import { useAuth } from '@/modules/context/AuthContext'
import DaycareSelector from '@/components/DaycareSelector/daycareSelector'

interface DaycareProfileProps {
    daycare: Daycare
}

const DaycareParentProfile: FunctionComponent<DaycareProfileProps> = ({ daycare }: DaycareProfileProps) => {
    const { t } = useTranslation()

    const { user } = useAuth()

    const daycareName: string = daycare.name
    const phone: string = daycare.phone
    const type: DaycareType = daycare.type
    const managerName: string = daycare.manager
    const email: string = daycare.email
    const address: string = daycare.address
    const zip: string = daycare.zip
    const city: string = daycare.city
    const country: string = daycare.country

    const monOpen: string | null =
        daycare.opening.monOpen !== null ? moment(daycare.opening.monOpen, 'HH:mm').format('HH:mm') : null

    const monClose: string | null =
        daycare.opening.monClose !== null ? moment(daycare.opening.monClose, 'HH:mm').format('HH:mm') : null

    const monBreakStart: string | null =
        daycare.opening.monBreakStart !== null ? moment(daycare.opening.monBreakStart, 'HH:mm').format('HH:mm') : null

    const monBreakEnd: string | null =
        daycare.opening.monBreakEnd !== null ? moment(daycare.opening.monBreakEnd, 'HH:mm').format('HH:mm') : null

    const tueOpen: string | null =
        daycare.opening.tueOpen !== null ? moment(daycare.opening.tueOpen, 'HH:mm').format('HH:mm') : null

    const tueClose: string | null =
        daycare.opening.tueClose !== null ? moment(daycare.opening.tueClose, 'HH:mm').format('HH:mm') : null

    const tueBreakStart: string | null =
        daycare.opening.tueBreakStart !== null ? moment(daycare.opening.tueBreakStart, 'HH:mm').format('HH:mm') : null

    const tueBreakEnd: string | null =
        daycare.opening.tueBreakEnd !== null ? moment(daycare.opening.tueBreakEnd, 'HH:mm').format('HH:mm') : null

    const wedOpen: string | null =
        daycare.opening.wedOpen !== null ? moment(daycare.opening.wedOpen, 'HH:mm').format('HH:mm') : null

    const wedClose: string | null =
        daycare.opening.wedClose !== null ? moment(daycare.opening.wedClose, 'HH:mm').format('HH:mm') : null

    const wedBreakStart: string | null =
        daycare.opening.wedBreakStart !== null ? moment(daycare.opening.wedBreakStart, 'HH:mm').format('HH:mm') : null

    const wedBreakEnd: string | null =
        daycare.opening.wedBreakEnd !== null ? moment(daycare.opening.wedBreakEnd, 'HH:mm').format('HH:mm') : null

    const thuOpen: string | null =
        daycare.opening.thuOpen !== null ? moment(daycare.opening.thuOpen, 'HH:mm').format('HH:mm') : null

    const thuClose: string | null =
        daycare.opening.thuClose !== null ? moment(daycare.opening.thuClose, 'HH:mm').format('HH:mm') : null

    const thuBreakStart: string | null =
        daycare.opening.thuBreakStart !== null ? moment(daycare.opening.thuBreakStart, 'HH:mm').format('HH:mm') : null

    const thuBreakEnd: string | null =
        daycare.opening.thuBreakEnd !== null ? moment(daycare.opening.thuBreakEnd, 'HH:mm').format('HH:mm') : null

    const friOpen: string | null =
        daycare.opening.friOpen !== null ? moment(daycare.opening.friOpen, 'HH:mm').format('HH:mm') : null

    const friClose: string | null =
        daycare.opening.friClose !== null ? moment(daycare.opening.friClose, 'HH:mm').format('HH:mm') : null

    const friBreakStart: string | null =
        daycare.opening.friBreakStart !== null ? moment(daycare.opening.friBreakStart, 'HH:mm').format('HH:mm') : null

    const friBreakEnd: string | null =
        daycare.opening.friBreakEnd !== null ? moment(daycare.opening.friBreakEnd, 'HH:mm').format('HH:mm') : null

    const satOpen: string | null =
        daycare.opening.satOpen !== null ? moment(daycare.opening.satOpen, 'HH:mm').format('HH:mm') : null

    const satClose: string | null =
        daycare.opening.satClose !== null ? moment(daycare.opening.satClose, 'HH:mm').format('HH:mm') : null

    const satBreakStart: string | null =
        daycare.opening.satBreakStart !== null ? moment(daycare.opening.satBreakStart, 'HH:mm').format('HH:mm') : null

    const satBreakEnd: string | null =
        daycare.opening.satBreakEnd !== null ? moment(daycare.opening.satBreakEnd, 'HH:mm').format('HH:mm') : null

    const sunOpen: string | null =
        daycare.opening.sunOpen !== null ? moment(daycare.opening.sunOpen, 'HH:mm').format('HH:mm') : null

    const sunClose: string | null =
        daycare.opening.sunClose !== null ? moment(daycare.opening.sunClose, 'HH:mm').format('HH:mm') : null

    const sunBreakStart: string | null =
        daycare.opening.sunBreakStart !== null ? moment(daycare.opening.sunBreakStart, 'HH:mm').format('HH:mm') : null

    const sunBreakEnd: string | null =
        daycare.opening.sunBreakEnd !== null ? moment(daycare.opening.sunBreakEnd, 'HH:mm').format('HH:mm') : null

    return (
        <div className={profileStyles.PagePosition}>
            {user && user?.daycares.length > 1 && (
                <div className={styles.SelectDaycare}>
                    <DaycareSelector />
                </div>
            )}
            <div className={styles.ProfilPlacement}>
                <div className={styles.Form}>
                    <div className={styles.Title}>
                        <Title text={daycareTypeToString(type, t)} />
                    </div>
                    <div className={styles.InputContainer}>
                        <div className={styles.Input}>
                            <UserInput
                                value={daycareName}
                                label={t('daycareName')}
                                readOnly
                                parent
                                fullWidth
                                className={styles.UserInput}
                            />
                            <UserInput
                                value={managerName}
                                label={t('managerName')}
                                readOnly
                                parent
                                fullWidth
                                className={styles.UserInput}
                            />
                        </div>
                        <div className={styles.Input}>
                            <UserInput
                                value={email}
                                label={t('email')}
                                type={'email'}
                                readOnly
                                parent
                                fullWidth
                                className={styles.UserInput}
                            />
                            <UserInput
                                value={phone}
                                label={t('phone')}
                                type={'phone'}
                                format={'phone'}
                                readOnly
                                parent
                                fullWidth
                                className={styles.UserInput}
                            />
                        </div>
                    </div>
                    <div className={styles.Title}>
                        <Title text={t('address')} />
                        <a
                            href={
                                'https://www.google.com/maps/search/?api=1&query=' +
                                `${address}+${zip}+${city}+${country}`
                            }
                            target='_blank'
                            rel='noreferrer'
                            className={styles.Icon}
                        >
                            <LocationOn />
                        </a>
                    </div>
                    <div className={styles.InputContainer}>
                        <div className={styles.Input}>
                            <UserInput
                                value={address}
                                label={t('address')}
                                readOnly
                                parent
                                fullWidth
                                className={styles.UserInput}
                            />
                            <UserInput
                                value={zip}
                                label={t('zipCode')}
                                readOnly
                                parent
                                fullWidth
                                className={styles.UserInput}
                            />
                        </div>
                        <div className={styles.Input}>
                            <UserInput
                                value={city}
                                label={t('city')}
                                readOnly
                                parent
                                fullWidth
                                className={styles.UserInput}
                            />
                            <div className={styles.UserInput}>
                                <CountrySelect country={country} readOnly parent />
                            </div>
                        </div>
                    </div>
                    {daycare.logoBase64Data && (
                        <img
                            src={`data:image/png;base64,${daycare.logoBase64Data}`}
                            alt={`${daycare.name} logo`}
                            className={styles.LogoDaycare}
                        />
                    )}
                    <div className={styles.Title}>
                        <Title text={t('openingHours')} />
                    </div>
                    <Table className={styles.OpeningHours}>
                        <TableBody>
                            <DayOpeningHours
                                day={t('monday')}
                                open={monOpen}
                                close={monClose}
                                breakStart={monBreakStart}
                                breakEnd={monBreakEnd}
                                firstLine
                            />

                            <DayOpeningHours
                                day={t('tuesday')}
                                open={tueOpen}
                                close={tueClose}
                                breakStart={tueBreakStart}
                                breakEnd={tueBreakEnd}
                            />

                            <DayOpeningHours
                                day={t('wednesday')}
                                open={wedOpen}
                                close={wedClose}
                                breakStart={wedBreakStart}
                                breakEnd={wedBreakEnd}
                            />

                            <DayOpeningHours
                                day={t('thursday')}
                                open={thuOpen}
                                close={thuClose}
                                breakStart={thuBreakStart}
                                breakEnd={thuBreakEnd}
                            />

                            <DayOpeningHours
                                day={t('friday')}
                                open={friOpen}
                                close={friClose}
                                breakStart={friBreakStart}
                                breakEnd={friBreakEnd}
                            />

                            <DayOpeningHours
                                day={t('saturday')}
                                open={satOpen}
                                close={satClose}
                                breakStart={satBreakStart}
                                breakEnd={satBreakEnd}
                            />

                            <DayOpeningHours
                                day={t('sunday')}
                                open={sunOpen}
                                close={sunClose}
                                breakStart={sunBreakStart}
                                breakEnd={sunBreakEnd}
                            />
                        </TableBody>
                    </Table>
                </div>
            </div>
        </div>
    )
}

export default DaycareParentProfile

interface DayOpeningHoursProps {
    day: string
    open: string | null
    close: string | null
    breakStart: string | null
    breakEnd: string | null
    firstLine?: boolean
}

const DayOpeningHours: FunctionComponent<DayOpeningHoursProps> = ({
    day,
    open,
    close,
    breakStart,
    breakEnd,
    firstLine
}: DayOpeningHoursProps) => {
    const { t } = useTranslation()

    return (
        <TableRow>
            <TableCell align={'center'} className={`${styles.DayParentTitle} ${firstLine && styles.NoMarginTop}`}>
                {day}
            </TableCell>
            <TableCell align={'center'} className={`${firstLine && styles.NoMarginTop}`}>
                {open != null && close != null ? (
                    <>
                        {open}
                        {breakStart != null && breakEnd != null ? (
                            <>
                                {` - ${breakStart}`}
                                <br />
                                {breakEnd}
                            </>
                        ) : null}
                        {` - ${close}`}
                    </>
                ) : (
                    t('closed')
                )}
            </TableCell>
        </TableRow>
    )
}
